export default "__VITE_ASSET__Bz2O5taU__"